import type { FlagVerdict } from '../schemas/flag';

/**
 * Why the flag resolves the way it does, not just whether it does.
 *
 * Each source carries its own preposition rather than sharing a "via " prefix —
 * "via the flag is archived" is not a sentence, and the two sources that are not
 * a *route* to a value (archived, unset) need different grammar from the three
 * that are.
 *
 * Lives in its own file because two screens read the same verdict from opposite
 * ends — `FlagDetailPage` lists the museums overriding one flag, the client's
 * flags tab lists the flags overridden for one museum — and the sentence that
 * explains a source has to be the same sentence in both.
 *
 * Separate from `VerdictBadge.tsx` rather than exported beside it: a module that
 * exports both a component and a constant defeats React Fast Refresh, which can
 * only swap a file whose exports are all components (`react-refresh/only-export-components`).
 * Separate from `grant-provenance-copy.ts` too — a verdict source is why the
 * platform resolved a value, a grant is who is holding a museum's row up, and
 * folding them together would put two unrelated vocabularies in one file.
 */
export const VERDICT_REASON: Record<FlagVerdict['source'], string> = {
    override: 'via this override',
    default: 'via the platform default',
    rollout: 'via the rollout gate',
    archived: 'because the flag is archived',
    unset: 'no row exists',
};
